import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SALES_URL } from '../../../constants/KnowledgeBaseUrls';
import { DELETED, INVALID_RECORDING_FORMAT, NOT_TRANSCRIBED_INACCESSIBLE_RECORDING, NOT_TRANSCRIBED_LIMIT_REACHED, NOT_TRANSCRIBED_NO_SEAT, SCHEDULED, STARTED } from '../../../types/TranscriptionRequestStatus';
import { Link } from 'foundations-components/transitional/components/Link';

// Function to get the title based on the status
import { jsx as _jsx } from "react/jsx-runtime";
function getTitle(status) {
  switch (status) {
    case STARTED:
    case SCHEDULED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.scheduled.title"
      });
    case DELETED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.deleted.title"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptAvailable"
      });
  }
}

// Function to get the illustration based on the status
function getIllustration(status, isTranscriptionAdmin, isUsageLimitReached) {
  switch (status) {
    case INVALID_RECORDING_FORMAT:
      return 'calling-transcript';
    case STARTED:
    case SCHEDULED:
      return 'errors/hourglass';
    case NOT_TRANSCRIBED_NO_SEAT:
      return 'calling-transcript-empty-state';
    case NOT_TRANSCRIBED_LIMIT_REACHED:
      if (isUsageLimitReached) {
        return 'keys';
      } else if (isTranscriptionAdmin) {
        return 'calling-transcript';
      }
      return 'calling-transcript-empty-state';
    case DELETED:
      return 'empty-state-charts';
    default:
      return 'calling-transcript';
  }
}

// Function to get the description based on the status
function getDescription(status, isTranscriptionAdmin, isUsageLimitReached) {
  switch (status) {
    case INVALID_RECORDING_FORMAT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.invalidRecordingFormat.description"
      });
    case STARTED:
    case SCHEDULED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.scheduled.description"
      });
    case NOT_TRANSCRIBED_NO_SEAT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedNoSeat.description"
      });
    case NOT_TRANSCRIBED_INACCESSIBLE_RECORDING:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedInaccessibleRecording.description"
      });
    case NOT_TRANSCRIBED_LIMIT_REACHED:
      if (isUsageLimitReached && isTranscriptionAdmin) {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedLimitReached.usageLimitReachedIsAdmin.description_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: SALES_URL,
            external: true
          }
        });
      } else if (isUsageLimitReached && !isTranscriptionAdmin) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedLimitReached.usageLimitReachedIsNotAdmin.description"
        });
      } else if (isTranscriptionAdmin) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedLimitReached.onlyRecordedAfterUsageLimitIncreasedIsAdmin.description"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptionStatus.notTranscribedLimitReached.onlyRecordedAfterUsageLimitIncreased.description"
      });
    default:
      return '';
  }
}

// Main function to get the info based on the transcription status
export function getTranscriptEmptyStateInfo(transcriptionStatus, isTranscriptionAdmin = false, isUsageLimitReached = false) {
  return {
    title: getTitle(transcriptionStatus),
    illustration: getIllustration(transcriptionStatus, isTranscriptionAdmin, isUsageLimitReached),
    description: getDescription(transcriptionStatus, isTranscriptionAdmin, isUsageLimitReached)
  };
}